import { numberToLatin, numberToRoman } from './number-formatting';
import type { PageNumberingConfig } from '../slate-api';

/**
 * Formats a page number according to the given configuration.
 * @param pageNumber The current page number (1-based).
 * @param config Optional configuration for formatting.
 * @returns The formatted page number as a string.
 */
export const formatPageNumber = (pageNumber: number, config?: PageNumberingConfig): string => {
  const pageNumberAdjusted =
    config?.start !== undefined ? pageNumber - 1 + config.start : pageNumber;

  if (!config?.format) return pageNumberAdjusted.toString();

  switch (config.format) {
    case 'decimal':
      return pageNumberAdjusted.toString();
    case 'lowerLetter':
      return numberToLatin(pageNumberAdjusted, false);
    case 'upperLetter':
      return numberToLatin(pageNumberAdjusted, true);
    case 'lowerRoman':
      return numberToRoman(pageNumberAdjusted, false);
    case 'upperRoman':
      return numberToRoman(pageNumberAdjusted, true);
    case 'numberInDash':
      return `- ${pageNumberAdjusted} -`;
    default:
      return pageNumberAdjusted.toString();
  }
};
